export const GRID_AREA_BADGE = 'badge';
export const GRID_AREA_TITLE = 'title';
export const GRID_AREA_CHIP = 'chip';
export const GRID_AREA_HISTORY_BUTTON = 'history-button';
